import React from 'react'
import Letter from './Letter/Letter'
import styles from './Puzzle.module.css'
import uuidv4 from 'uuid/v4'
import { connect } from 'react-redux'

const Puzzle = props => {
  // turn props.phrase into array of three separate words
  const words = props.game.puzzle.split(' ')
  
  // make a function that takes in a word, split into an array, and finally return a word component from phrase component
  const wordElement = (word) => {
    const letters = word.map((letter) => {
      return (
        <Letter
          key={uuidv4()}
          letter={letter}
        />
      )
    })
    return letters
  }
  
  // create three variables that call above function
  const wordOne = wordElement(words[0].split(''))
  const wordTwo = wordElement(words[1].split(''))
  const wordThree = wordElement(words[2].split(''))

  let gamePuzzle = <h2 style={{ color: '#fff' }}>Loading...</h2>
  if (props.puzzle !== 'some dummy data') { 
    gamePuzzle = (
      <section className={styles.Puzzle}>
        <div className={styles.Word}>{wordOne}</div>
        <div className={styles.Word}>{wordTwo}</div>
        <div className={styles.Word}>{wordThree}</div>
      </section>
    )
  }

  return gamePuzzle
}

const mapStateToProps = state => {
  return {
    game: state.puzzle.game,
    puzzle: state.puzzle.puzzle,
    correctGuessesCount: state.puzzle.correctGuessesCount
  }
}

export default connect(mapStateToProps)(Puzzle)